module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_4.76b4f897.pdf";